import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/shared/services/event.service';
import { EventInfoWithConsentResponse, ConsentAcceptanceRequest, ConsentControllerService } from '@ent-regis/entregis-ts-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-company-consent',
  templateUrl: './company-consent.component.html',
  styleUrls: ['./company-consent.component.scss']
})
export class CompanyConsentComponent implements OnInit {

  private subscription: Subscription;
  public eventInfo: EventInfoWithConsentResponse;

  constructor(
    private eventService: EventService,
    private consentService: ConsentControllerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.subscription = new Subscription();

    this.subscription.add(this.eventService.eventSubject.subscribe(x => {
      this.eventInfo = x;
    }));
  }

  private getRegisterCompanyId(): string | null {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.paramMap.get('registerCompanyId');
  }

  acceptConsent(data: ConsentAcceptanceRequest[]) {
    this.consentService.acceptConsentUsingPOST(data).subscribe(x => {
      this.router.navigate(['regis', this.eventInfo.eventAlias, this.authService.loginType, this.getRegisterCompanyId()]);
    });
  }

}
